
import store from "@/store/index"
import { setErrorMessage, handleFetchError } from './FetchErrorHandler'
import { getLevel } from '@/utils/chat/chatUtil';
import { getToken, getUser } from '@/utils/auth'


export const CONTENT_TYPE_JSON = "application/json;charset=utf-8";
export const SPLIT_SINAL = '}\n{';

export async function fetchAndProcessData(url, data, handleDataFunction) {
  let readTimeout = null
  let responseChunk = ''
  let parsedJson = null
  let { question, aiContent, params } = data
  let options = {
    method: 'POST',
    signal: params.signal
  }
  options.headers = new Headers({
    "Content-Type": CONTENT_TYPE_JSON,
    "Authorization": getToken(),
    "username": getUser() && getUser().phoneNumber
  })
  let level = ""
  const withOutLevelUrls = ["/Composition"];
  if (question && question.level) {
    level = question.level
  }
  if (!level) {
    level = getLevel()
  }
  if (!withOutLevelUrls.some(target => url.includes(target))) {
    const { signal, ...bodyParams } = params;
    options.body = JSON.stringify({
      ...bodyParams,
      level
    });
  }

  try {
    const response = await fetch(url, options)
    if (!response.ok) {
      console.log(response.status)
      setErrorMessage(response.status || 3, aiContent)
    }
    const reader = response.body.getReader()
    async function readChunk() {
      const { done, value } = await reader.read()
      if (done) {
        console.log('全部数据接收完毕')
        if (aiContent) {
          aiContent.isDone = 1

          // aiContent.delProp(aiContent, "controller")
          if (aiContent.msg === "loading") {
            aiContent.msg = ""
          }
          await store.dispatch('updateMessageToConversation', {
            message: aiContent
          });
        }
        clearTimeout(readTimeout)
        if (question) {
          question.isLoading = false

        }
        reader.releaseLock()
        return
      }

      clearTimeout(readTimeout)
      responseChunk += new TextDecoder().decode(value)
      if (responseChunk.includes(SPLIT_SINAL)) {
        responseChunk = responseChunk.replaceAll(SPLIT_SINAL, '},{').replaceAll('}\n', '}').split(',')
      }

      // 尝试解析JSON
      try {
        parsedJson = JSON.parse(`[${responseChunk}]`)
      } catch (error) {
        // 如果解析失败，继续读取下一个块
        // console.error('Error parsing JSON:', error)
        return readChunk()
      }

      // 处理解析后的JSON
      if (parsedJson) {
        if (parsedJson instanceof Array) {
          for (const json of parsedJson) {
            handleDataFunction(json, aiContent, question)
          }
        } else {
          handleDataFunction(parsedJson, aiContent, question)
        }
        responseChunk = ''
      }

      return readChunk()
    }

    // 开始读取数据块
    readChunk()

  } catch (error) {
    if (aiContent?._aborted) {
      clearTimeout(readTimeout);
      return;
    }
    handleFetchError(error, aiContent, question)
  } finally {
    clearTimeout(readTimeout)
  }
}

export function handleChatParams(data) {
  let { aiContent } = data;
  let params = aiContent.params;
  params.query = params.text;
  params.signal = aiContent?.controller.signal
  // params.signal =  new AbortController().signal 
  data.params = params;
  return data;
}

export function handleQuestionParams(data) {
  let params = { ...data }
  if (params.question) delete params.question
  data.params = params
  // params.id = data.id;
  return data;
}

export function hanldeWallParams(data, knowledge) {
  return {
    aiContent: data,
    params: {
      knowledge,
      signal: data.controller.signal,
      // signal: new AbortController().signal 


    }
  }
}

export function handleSimilarParams(data) {
  data.params = {
    id: data.question.id,
    signal: data.aiContent?.controller?.signal
    // signal: new AbortController().signal 

  }
  return data
}


